import { useEffect, useState } from "react";
import problemServices from "app/services/problem-service";

const useTags = () => {
  const [tags, setTags] = useState([]);

  const fetchTags = async () => {
    try {
      const res = await problemServices.getUniqueProblemTags();
      setTags(res);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchTags();
  }, []);
  return { tags };
};
export default useTags;
